export default {
  organizations: [],
  selectedOrganization: {},
  organizationUsers: []
}
